import React, { useEffect, useState } from 'react';
import PhotoCard from './PhotoCard';
import PhotoFocus from './PhotoFocus';
import useMorphingBackground from '../hooks/useMorphingBackground';
import { Drawer } from 'antd';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const PhotoExplorer = (props) => {
    const backgroundSetter = props?.backgroundSetter
    const filterOptions = props?.filterOptions
    const [allPhotos, setAllPhotos] = useState(null);
    const [focusedIndex, setFocusedIndex] = useState(null);
    useMorphingBackground(allPhotos, backgroundSetter);


    // Check URL for photo ID on mount
    useEffect(() => {
        const onPop = () => {
            const params = new URLSearchParams(window.location.search);
            const photoId = params.get('photo');
            if (photoId && allPhotos) {
                const photo = allPhotos.find(p => p.id === parseInt(photoId));
                if (photo) {
                    setFocusedIndex(allPhotos.indexOf(photo));
                }
            }
        }
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, [allPhotos]);

    // Fetch photos based on filters
    useEffect(() => {
        let fetchUrl = `${API_URL}/photos/list/`
        if (filterOptions?.['subject']?.length > 0) {
            fetchUrl += `?subject__name=${filterOptions['subject']},`
        }
        if (filterOptions?.['tags']?.length > 0) {
            fetchUrl += `?tags__name=${filterOptions['tags']},`
        }
        if (filterOptions?.['location']?.length > 0) {
            fetchUrl += `?location__name=${filterOptions['location']},`
        }
        console.log(fetchUrl);
        fetch(fetchUrl, { method: "GET" })
            .then((res) => {
                res.json()
                    .then((j) => {
                        // randomize order of j
                        j.sort(() => Math.random() - 0.5);
                        setAllPhotos(j)
                    })
                    .catch(console.error) // API response couldn't be parsed
            })
            .catch(console.error)

    }, [filterOptions])

    const handleSetFocus = (photoIdx, { replace = false } = {}) => {
        setFocusedIndex(photoIdx);
        if (photoIdx === null) {
            window.history.pushState({}, '', window.location.pathname);
            return;
        } 

        const photo = allPhotos[photoIdx];
        if (!photo) return;
        
        const method = replace ? 'replaceState' : 'pushState';
        window.history[method]({}, '', `${window.location.pathname}?photo=${photo.id}`);
    }

    if (!allPhotos) { return (<h1>Failed to fetch photos :(</h1>) }


    return (
        <>
            <div class="cards grid" style={{ width: "100%", justifyContent: "center", justifyItems: "center" }}>
                {allPhotos?.map(photo => (
                    <>
                        <PhotoCard photo={photo} setFocus={(photo) => handleSetFocus(allPhotos.indexOf(photo))} class="card" />
                    </>
                ))}
            </div>
            <Drawer 
              open={focusedIndex !== null} 
              onClose={() => handleSetFocus(null)} 
              width="100%" 
              height="100%"
              closable={false} 
              style={{background: '#0a0a0af0'}}
              mask={false}
              getContainer={() => document.body}
            >
                {focusedIndex !== null && (
                    <PhotoFocus 
                        photoIndex={focusedIndex} 
                        setFocus={handleSetFocus} 
                        setNext={
                            () => handleSetFocus(
                                (focusedIndex +1) % allPhotos.length,
                                { replace: true }
                            )
                        }
                        setPrev={
                            () => handleSetFocus(
                                (focusedIndex -1 + allPhotos.length) % allPhotos.length,
                                { replace: true }
                            )
                        }
                        photoSet={allPhotos} 
                    />
                )}
            </Drawer>
        </>
    )
}

export default PhotoExplorer;